import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/index";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/")(withAlternates(routeOptions, "/"));
